import React from 'react'
import "./MovieMania.css"
import img1 from "../../assets/Movie1.png" 
import { Link } from 'react-router-dom'
import {HiLocationMarker} from "react-icons/hi"
import pdfLink from "../../assets/Rules.pdf"
const MovieMania = () => {
  return (
    <div className='movie_container'>
        <div className="title">
            <h2>Movie Mania</h2>            
        </div>
        <div className="evt_data">
            <div className="left">
                <img src={img1} alt="" />
            </div>
            <div className="right">
                <div className="r_detail">
                <p>Mar 14,2023</p>
                <h2>  <span> Short Film </span>Direction (Team)</h2>
                </div>
                <div className="reg_data">
                    <div className="flex-cont">
                <div className="evt_reg">
                    <h2>Entry Fee : Rs. 100</h2>
                    <div className="reg_btns">
                    <Link to="https://docs.google.com/forms/d/1UGbZ59hC-xTmL0IX7EmljcmgJw64D2lSrlYSzakahJo/viewform?edit_requested=true" target="_blank" className="reg_btn">Register Now</Link>
                    </div>
                    </div>
                </div>
                <div className="desc">
                    <h3>Description</h3>
                     <p>The Short Film event is a competition showcasing short films created by students from a particular institute or college.The event provides an opportunity for aspiring filmmakers to showcase their talent and creativity to their peers, faculty, and judges. Typically, the event includes a screening of the short films followed by an award ceremony to recognize outstanding achievements in various categories.</p>
                     <Link to={pdfLink} target="_blank" className="reg_btn">Rules & Regulations</Link>
                </div>
                <div className="vid">
                    <h3 > <span> Video </span> Submission : </h3>
                     <p>Submit the Video in the form of Drive Link on Number : <span> +91 8879450932 </span></p>
                </div>
                <div className="date">
                    <h3> <span> Date </span> & Time</h3>
                    <div className="date_data">
                        <h4>Mar 14,2023</h4>
                    </div>
                </div>
                <div className="loc">
                    <h3> <span> Location</span></h3>
                    <p> <HiLocationMarker/>College of Engineering and Technology,Akola</p>
                </div>
                <div className="team">
                    <h3><span>Coordinator</span> Team</h3>
                    <div className="staf_team">
                        <h4>Staff Co-ordinator</h4>
                        <p>Rutuja Deskmukh : +91 8208958520</p>
                        <p>Vasanti Gaud: +91 9421424756 </p>
                    </div>
                    <div className="team_data">
                        <h4>Student Co-ordinator</h4>
                        <p>Vaibhav Meshram : +91 8879450932</p>
                        <p>Amruta Giramkar: +91 8329818804</p>
                        <p>Komal Wadi : +91 9130660680</p>
                        <p>Mayur Joshi : +91 9765244547</p>
                        <p> Sahil Borade : +91 8830414276</p>
                        <p> Sarthak Gore : +91 7410582536</p>
                        <p> Oscar Salve : +91 8698157475</p>
                        <p> Rigveda  : +91 866975584</p>
                        <p> Janhvi Patel: +91 7498114410</p>
                        <p> Jawwad : +91 8847718760</p>
                        <p> Renuka: +91 8080026067</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MovieMania